import React, { createContext, useContext, useMemo, useState } from 'react';

// Избраният салон (от стъпката „Избери салон“ в резервациите). null = няма избран.
// Ползва се от плаващия бутон за обаждане, за да звъни на правилния номер.
const SalonContext = createContext({ selectedLocationId: null, setSelectedLocationId: () => {} });

export function SalonProvider({ children }) {
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const value = useMemo(() => ({ selectedLocationId, setSelectedLocationId }), [selectedLocationId]);
  return <SalonContext.Provider value={value}>{children}</SalonContext.Provider>;
}

export const useSalon = () => useContext(SalonContext);
